@if (usage$ | async; as usage) {
  <div class="mt-2">
    @switch (usage.status) {
      @case (WarehouseSkuUsageStatus.New) {
        <div class="text-sm text-green-500">
          <span>Brak towaru o podanym SKU.</span>
        </div>
      }

      @case (WarehouseSkuUsageStatus.OccurringInGood) {
        <div class="text-sm text-red-500">
          Istnieje towar o podanym SKU: {{ usage.product?.name }}.
        </div>
      }

      @case (WarehouseSkuUsageStatus.OccurringInReceipts) {
        <div class="text-sm text-orange-500">
          <span>
            Brak towarów o podanym SKU. Numer SKU występuje w przyjęciach:
          </span>

          @for (
            receipt of valueOrDefault(usage.receipts, []);
            let isLast = $last;
            track receipt.id
          ) {
            <span>{{ receipt.number }}</span>

            @if (!isLast) {
              <span>, </span>
            }
          }
          <span>.</span>
        </div>
      }
    }
  </div>
}
